import React from "react";
import type { Meal } from "../meal";
import MenuItem from "../MenuItem/MenuItem";
import "./menuList.scss";

type Props = {
  categoryName: string;
  meals: Meal[];
};

const MenuList = ({ categoryName, meals }: Props) => {
  const sorted = [...meals].sort((a, b) => a.id - b.id);

  if (!sorted.length) {
    return null;
  }

  return (
    <div className="delivery-menu-section">
      <h2 className="delivery-menu-section__title">{categoryName}</h2>
      <div className="delivery-menu-section__grid">
        {sorted.map((meal) => (
          <MenuItem key={meal.id} meal={meal} />
        ))}
      </div>
    </div>
  );
};

export default MenuList;
